import script from "./DeliverStrategyPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliverStrategyPanel.vue?vue&type=script&setup=true&lang=js"

import "./DeliverStrategyPanel.vue?vue&type=style&index=0&id=b53d2b38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b53d2b38"]])

export default __exports__